module.exports = __webpack_public_path__ + "8fb1e2c47fa087ad0e6b0877e04cd62f.pdf";